import {use} from 'react';

import {DroppableDropContext} from '../droppableDropContext';
import {DragAndDropContextType} from '../types';

export const useFullDnDContext = <TDnDData>(): DragAndDropContextType<TDnDData> => {
  const ctx = use(DroppableDropContext) as DragAndDropContextType<TDnDData>;
  return ctx;
};
